import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { browserHistory } from 'react-router';

import SiteNav from '../SiteNav';
import LegalFooter from '../LegalFooter';

import { useScrollToTop } from '@evdy/web-core/dist/customHooks';
import { useGetWebleadFromCookie } from '../../customHooks';

import { purchaseFlowOperations } from '@evdy/web-redux/dist/lib/webPurchase/purchaseFlow';
import { authUserOperations } from '@evdy/web-redux/dist/lib/authUser';

import styles from './PreparingPackage.module.scss';

import purpleLoveHeart from '../../public/images/purple-love-heart-icon.svg';
import blueLoadingCircle from '../../public/images/blue-loading-circle-icon.svg';

const { userStartSale } = authUserOperations;

const {
  'preparing-package': preparingPackageClass,
  'preparing-package-content': preparingPackageContentClass,
  'loading-circle': loadingCircleClass
} = styles;

const PreparingPackage = () => {
  const dispatch = useDispatch();
  const { authUser = {}, purchaseFlow = {} } = useSelector(({ authUser, webPurchase }) => ({
    authUser,
    purchaseFlow: webPurchase?.purchaseFlow
  }));

  // assign most prioritized user data
  const { data: userData } = useMemo(() => {
    return !!authUser?.data?._id ? authUser : purchaseFlow;
  }, [authUser, purchaseFlow]);

  const { _id: userId, eFuneral } = userData || {};
  const { funeralHomeId: homeObj, paymentOption, packageData, url } = eFuneral || {};
  const { _id: funeralHomeId } = homeObj || {};

  const packageNumber = packageData?.number;
  const preneedPackageId = homeObj?.preneedPackages?.homePackageIds?.[0][`package${packageNumber}`];

  // scroll to top on mount
  useScrollToTop();

  // on mount, check if weblead cookie exists and fetch existing weblead
  useGetWebleadFromCookie();

  // submit sale to begin efuneral purchase process on mount
  useEffect(() => {
    // if weblead exists and does not have an eFuneral purchase url yet,
    // start a new sale
    if (userId && !url) {
      const startSaleObj = {
        userId,
        funeralHomeId,
        preneedPackageId,
        paymentOption
      };

      if (authUser?.data?._id) {
        dispatch(userStartSale(startSaleObj));
      } else {
        dispatch(purchaseFlowOperations.startSale(startSaleObj));
      }
    }
  }, [userId, url]);

  // once eFuneral returns the sale url, navigate the page to the eFuneral
  // iframe flow
  useEffect(() => {
    if (url) {
      browserHistory.push('/b/e-funeral-purchase');
    }
  }, [url]);

  return (
    <div className={preparingPackageClass}>
      <SiteNav />
      <div className={preparingPackageContentClass}>
        <img src={purpleLoveHeart} alt="heart-icon" />
        <h3>We’re getting everything ready now</h3>
        <img src={blueLoadingCircle} className={loadingCircleClass} alt="loader-circle" />
        <h5>Hang on - only takes a moment...</h5>
      </div>
      <LegalFooter />
    </div>
  );
};

export default PreparingPackage;
